// Hook ponownej realizacji oferty okresowej - POST /sales-crm/my-offers/:id/fulfill

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IPostSalesCrmMyOfferFulfillResponse {
  status: string;
  show_modal: boolean;
  message: string;
  message_style: string | null;
  show_message: boolean;
  show_field_infos: boolean;
  hold: boolean;
  /**
   * Wynik fulfillmentu - zawsze powstaje koszyk (cart_id),
   * order_id jest ustawiony tylko dla ofert typu DIRECT_ORDER.
   */
  data: {
    cart_id: number;
    order_id: number | null;
  };
  fields_info?: unknown[];
}

const postSalesCrmMyOfferFulfill = (
  offerId: string | number
): Promise<IPostSalesCrmMyOfferFulfillResponse> =>
  axios.post(`/sales-crm/my-offers/${offerId}/fulfill`);

export const usePostSalesCrmMyOfferFulfill = (
  offerId: string | number,
  options?: UseMutationOptions<IPostSalesCrmMyOfferFulfillResponse, IError, void>
) => useMutation(() => postSalesCrmMyOfferFulfill(offerId), options);
